<template>
  <b-modal v-if="item != null" body-bg-variant="soft-secondary" header-bg-variant="soft-secondary" @hidden="closePreview()" @close="closePreview()" :visible="show" size="xl" name="previewProductModal" id="preview-product-modal"  hide-footer>
    <template v-slot:modal-title>
      <h4 class="modal-title">{{ item.lender.lenderName }}: {{ item.description }}</h4>
    </template>
    <div class="d-block text-center">
      <ProductCard :item="item" :query="query" hide-header preview-mode/>
    </div>
    <button class="btn btn-soft-secondary btn-sm mt-3" @click="closePreview()">Close</button>
  </b-modal>
</template>

<script>
import ProductCard from "@/components/products/ProductCard";

export default {
  name: "ProductPreview",
  
  components: {
    ProductCard
  },
  
  data() {
    return {
      query: {
        propertyValue: 550000,
        remainingBalance: 350000,
        term: 16
      }
    }
  },
  
  methods: {
    closePreview() {
      this.$emit("close-preview");
    }
  },
  
  props: {
    show: Boolean,
    item: Object
  }
}
</script>

<style scoped>

</style>